import React from 'react';
import { faUndo, faCopy, faTrash } from '@fortawesome/free-solid-svg-icons';
import DashItemMenu from 'components/DashItemMenu';

const ArchiveListItemMenu = ({ onRestore, onDuplicate, onDelete }) => {
  const items = [
    {
      onClick: onDelete,
      icon: faTrash,
      title: ' Delete',
    },
  ];

  if (onRestore) {
    items.push({
      onClick: onRestore,
      icon: faUndo,
      title: ' Restore',
    });
  }

  if (onDuplicate) {
    items.push({
      onClick: onDuplicate,
      icon: faCopy,
      title: ' Duplicate',
    });
  }

  return <DashItemMenu items={items} />;
};

export default ArchiveListItemMenu;
